import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import Modal from "react-bootstrap/Modal";
import { pushNotification } from "utils/notifications";
import DanhSachNhanVienApi from "service/danhSachNhanVienApi";

export const ModalKhoa = ({ toggleModal, isModalVisible, item, onSearch}) => {
  const [bDisable, setDisableButton] = useState(false);
  const KhoaTaiKhoan = () => {
    setDisableButton(true);
    console.log("data khoa",item);
    item.Status = false;
    DanhSachNhanVienApi.lockNhanVien(item).then((response) => {
      setDisableButton(false);
      if (response.status === 200) {
        onSearch();
        toggleModal();
        pushNotification("Thao tác thành công", "success", "TOP_CENTER", 2000);
      } else {
        pushNotification(response.data, "error", "TOP_CENTER", 2000);
      }
    });
  };
  useEffect(() => {}, []);
  return (
    <Modal
      show={isModalVisible}
      size="modal-lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      className="modal-new modal fade text-left"
    >
      <Modal.Header>
        <h4 className="modal-title" id="myModalLabel16">
          <span className="btn-icon-right">
            <i className="mdi mdi-delete"></i>
          </span>
          Xác nhận khóa tài khoản
        </h4>
        <button type="button" className="close-popup-new" onClick={toggleModal}>
          <i className="mdi mdi-close"></i>
        </button>
      </Modal.Header>
      <Modal.Body className="">
        <div class="body-detail-bc">
          <div class="form-money-2" style={{ marginBottom: "5px" }}>
            <div class="row">
              <div class="col-sm-12">
                <span >
                  Bạn có chắc chắn muốn khóa tài khoản không?
                </span>
              </div>
            </div>
          </div>
        </div>
      </Modal.Body>
      <Modal.Footer>
        <div class="from-button-modal">
          <div class="row">
            <div class="col-md-6"></div>
            <div class="col-md-6 text-right">
              <button
                className="btn btn-new-main btn-checknew"
                onClick={(e) => KhoaTaiKhoan()}
                disabled={bDisable}
              >
                <span className="btn-icon-left">
                  <i className="mdi mdi-check"></i>
                </span>
                Xác nhận
              </button>
              <button
                type="button"
                class="btn btn-new-main btn-closenew"
                onClick={toggleModal}
                style={{ marginLeft: "5px" }}
              >
                <span class="btn-icon-left">
                  <i class="mdi mdi-close"></i>
                </span>
                Đóng
              </button>
            </div>
          </div>
        </div>
      </Modal.Footer>
    </Modal>
  );
};
